import DynamicFieldsSerializer from '@linc-technologies/linced-common/serializers/dynamic-fields';

export default class BulkImportMedicalContact extends DynamicFieldsSerializer {
  _fieldsKey = 'relationshipFields';
}
